// angular imports
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

// cc-common imports
import { IconConstants, Utils } from 'cc-common';

// service imports
import { UserService } from '../../../_services/data-services/user.service';

// model imports
import { WFVendorHistoryParametersDto } from '../../../shared-workflow-module/_models/wf-vendor-history-parameters-dto';
import { WFEVendorResultDto } from '../../../shared-workflow-module/_models/wfe-vendor-result-dto';

@Component({
    selector: 'app-workflow-payment-request-toolbar',
    templateUrl: './workflow-payment-request-toolbar.component.html',
    styleUrls: ['./workflow-payment-request-toolbar.component.scss']
})
export class WorkflowPaymentRequestToolbarComponent implements OnInit, OnChanges {
    @Input() selectedVendor: WFEVendorResultDto;
    @Input() boardApproval: boolean;
    @Input() communityId: number;
    @Input() invoiceOption: string;

    @Output() onAdvanceModeSelectionChange = new EventEmitter<boolean>();
    @Output() onWorkOrderSelection = new EventEmitter<number[]>();

    showVendorNotesPopUp = false;

    showVendorHistory = false;
    vendorHistoryBaseParams: WFVendorHistoryParametersDto;

    showWorkOrder = false;
    showAdvanceMode = false;
    showBoardApproval = false;
    workOrderIds: Array<number> = [];

    iconNotes = IconConstants.NOTES_AVAILABLE;
    iconEmptyNotes = IconConstants.NOTES_EMPTY;
    iconHistory = IconConstants.HISTORY;
    iconCheck = IconConstants.CHECK;
    iconHardHat = IconConstants.HARD_HAT;
    iconClose = IconConstants.CLOSE;

    isInternalUser: boolean;

    constructor(private readonly userService: UserService) {}

    ngOnInit() {
        this.isInternalUser = this.userService.isInternal();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (
            Utils.notNullAndDefined(changes.invoiceOption) &&
            Utils.notNullAndDefined(changes.invoiceOption.currentValue)
        ) {
            if (Utils.equalsIgnoreCase(this.invoiceOption, 'generate_payment_request')) {
                this.showAdvanceMode = true;
            } else {
                this.showAdvanceMode = false;
            }
        }
    }

    onVendorActivitiesClick(): void {
        this.vendorHistoryBaseParams = new WFVendorHistoryParametersDto();
        this.vendorHistoryBaseParams.communityId = this.communityId;
        this.vendorHistoryBaseParams.vendorCode = this.selectedVendor.vendorCode;
        this.showVendorHistory = true;
    }

    onVendorHistoryClose(): void {
        this.showVendorHistory = false;
    }

    onVendorNotesClick(): void {
        this.showVendorNotesPopUp = true;
    }

    onVendorNotesClose(isNotesSaved: boolean): void {
        this.showVendorNotesPopUp = false;
        this.selectedVendor.hasNotes = isNotesSaved;
    }

    onBoardApprovalClick(): void {
        this.showBoardApproval = true;
    }

    onBoardApprovalClose(): void {
        this.showBoardApproval = false;
    }

    onAdvanceModeValueChange(): void {
        this.onAdvanceModeSelectionChange.emit(this.showAdvanceMode);
    }

    onWorkOrderClick(): void {
        this.showWorkOrder = true;
    }

    onWorkOrderSelectorClose(): void {
        this.showWorkOrder = false;
    }

    onWorkOrderIdSelection(workOrderIds: Array<number>): void {
        this.workOrderIds = workOrderIds;
    }
}
